<fieldset [disabled]="editable">
	<div class="row row-no-padding mx-2">
		<div class="col-6 px-2">
			<div class="mb-3">
				<mat-form-field class="w-100" matTooltip="Nazwa generuje się na stronie i w systemie">
					<input matInput type="text" id="name" name="name" [(ngModel)]="service.data.name" required />
					<mat-label for="name">Nazwa produktu</mat-label>
				</mat-form-field>
			</div>
		</div>
		<div class="col-6 px-2">
			<div class="mb-3">
				<mat-form-field
					class="w-100"
					matTooltip="Jeden z wybranych typów/rodzajów wyjazdu. (Wybór typu produktu determinuje koniecznie do uzupełnienia pola w dalszych krokach)"
				>
					<mat-label for="type">Typ produktu</mat-label>
					<mat-select
						id="type"
						name="type"
						[(ngModel)]="service.data.productKind"
						(ngModelChange)="changeProductType()"
						[disabled]="pageFunction === 'edit'"
						required
					>
						<mat-option disabled>(wybierz)</mat-option>
						@for (item of service.mockData.productKind; track item.id) {
							<mat-option [value]="item.id"> {{ item.id }} | {{ item.name }} </mat-option>
						}
					</mat-select>
				</mat-form-field>
			</div>
		</div>
	</div>
	<div class="mb-3 mx-2">
		<mat-form-field
			class="w-100 px-2"
			matTooltip="Wybieramy z listy, na której są przypisane dane produkty do konkretnego operatora."
		>
			<mat-label for="operator">Operator:</mat-label>
			<mat-select
				id="operator"
				name="operator"
				[(ngModel)]="service.data.organization"
				[disabled]="editable"
				required
			>
				<mat-option disabled>(wybierz)</mat-option>
				@for (item of service.mockData.organization; track item.id) {
					<mat-option [value]="item.id"> {{ item.id }} | {{ item.name }} </mat-option>
				}
			</mat-select>
		</mat-form-field>
	</div>
	<div class="mb-3 mx-2 d-flex flex-row gap-3 px-2">
		<mat-form-field class="w-100">
			<mat-label>Ubezpieczyciel:</mat-label>
			<input
				matInput
				type="text"
				[disabled]="editable"
				required
				[formControl]="insurerFormControl"
				[matAutocomplete]="insurerAutocomplete"
			/>
			<mat-autocomplete
				#insurerAutocomplete="matAutocomplete"
				[displayWith]="displayByName"
				(optionSelected)="selectInsurer($event)"
			>
				@for (insurer of filteredInsurers$ | async; track insurer.id) {
					<mat-option [value]="insurer">
						{{ insurer.name }}
					</mat-option>
				}
			</mat-autocomplete>
			@if (insurerFormControl.errors?.['required']) {
				<mat-error>To pole jest wymagane</mat-error>
			}
		</mat-form-field>
		<mat-form-field class="w-100">
			<mat-label>Pakiet ubezpieczenia dodatkowego:</mat-label>
			<input
				matInput
				type="text"
				required
				[formControl]="insuranceFormControl"
				[matAutocomplete]="insuranceAutocomplete"
				[disabled]="editable"
			/>
			<mat-autocomplete
				#insuranceAutocomplete="matAutocomplete"
				[displayWith]="displayByName"
				(optionSelected)="selectInsurance($event)"
			>
				@for (insurance of filteredInsurances$ | async; track insurance.id) {
					<mat-option [value]="insurance">
						{{ insurance.name }}
					</mat-option>
				}
			</mat-autocomplete>

			@if (insuranceFormControl.errors?.['required']) {
				<mat-error>To pole jest wymagane</mat-error>
			}
		</mat-form-field>
	</div>
	<div class="mb-3 mx-2">
		<div
			class="w-100 px-2"
			matTooltip="Tagi opisują produkt, imprezę, wyjazd. Tagi ułatwiają wyszukiwanie produtków."
		>
			<ng-select
				id="tags"
				name="tags"
				placeholder="Tag-i opisujące produkt"
				[(ngModel)]="service.data.tags"
				[disabled]="editable"
				[multiple]="true"
			>
				@for (item of service.mockData.tags; track item.id) {
					<ng-option [value]="item.id">
						{{ item.name }}
					</ng-option>
				}
			</ng-select>
		</div>
	</div>
	@if ([2, 3].includes(service.data.productKind)) {
		<div
			class="mb-3 mx-2 px-2"
			matTooltip="Jeżeli danej lokalizacji nie ma na liście możesz ją stworzyć w Ustawieniach Systemu lokalizacje!"
		>
			<label for="destination" class="mt-2">Destynacje (miasta & kraje)</label>
			<ng-select
				id="destination"
				name="destination"
				[(ngModel)]="service.data.location"
				[disabled]="editable"
				[multiple]="true"
				required
			>
				@for (item of service.mockData.location; track item.id) {
					<ng-option [value]="item.id">
						{{ item.name }}
						<small>
							({{ item.parentLocation?.name }}, {{ item.parentLocation?.parentLocation?.name }})
						</small>
					</ng-option>
				}
			</ng-select>
		</div>
	}
	@if (![2, 3].includes(service.data.productKind)) {
		<div class="row mx-2 mb-3 h-100">
			<div class="col-5 px-2">
				<ng-select
					id="location"
					name="location"
					[(ngModel)]="service.data.location[0]"
					(change)="changeLocationCode()"
					placeholder="Lokalizacja *"
					[disabled]="editable"
					ng-required="true"
				>
					<ng-option disabled>(wybierz)</ng-option>
					@for (item of service.mockData.location; track item.id) {
						<ng-option [value]="item.id">
							{{ item.name }}
							<small>
								({{ item.parentLocation?.name }}, {{ item.parentLocation?.parentLocation?.name }})
							</small>
						</ng-option>
					}
				</ng-select>
			</div>
			<div class="col-4 px-2">
				<mat-form-field class="w-100">
					<input matInput type="text" id="address" name="address" [(ngModel)]="service.data.address" />
					<mat-label for="address" style="left: auto">Adres</mat-label></mat-form-field
				>
			</div>
			<div class="col-2 px-2">
				<mat-form-field class="w-100">
					<input matInput type="text" id="zipCode" name="zipCode" [(ngModel)]="service.data.zipCode" />
					<mat-label for="zipCode" style="left: auto">Kod Pocztowy</mat-label>
				</mat-form-field>
			</div>
			<div class="col-1 mb-3 px-2">
				<mat-form-field class="w-100">
					<input
						matInput
						type="text"
						id="buildingNumber"
						name="buildingNumber"
						[(ngModel)]="service.data.buildingNumber"
					/>
					<mat-label for="buildingNumber">Numer budynku</mat-label>
				</mat-form-field>
			</div>
			<div class="my-3 col-12 px-2 d-flex align-items-center">
				<mat-form-field class="w-50">
					<input
						matInput
						type="text"
						id="coordinates"
						name="coordinates"
						[(ngModel)]="service.mockData.coordinates"
					/>
					<mat-label for="coordinates">Koordynacje</mat-label>
				</mat-form-field>
				@if (service.data.productKind === ProductKind.VACATION) {
					<div class="w-50 d-flex justify-content-center align-items-center">
						<span class="pe-2">Liczba gwiazdek:</span>
						<app-stars [(selectedStarsNumber)]="service.data.stars" [disabled]="editable"></app-stars>
					</div>
				}
			</div>
		</div>
	}
	<div class="row mx-2 mb-3">
		<div class="col-2 px-2">
			<h6>
				Kod produktu
				<i
					class="fa fa-circle-info"
					matTooltipPosition="above"
					matTooltip="Kod produktu generuje się automatycznie. 1. człon: skrót typu produktu (np. wycieczka objazdowa: WO) 2. człon to kod ISO nazwy kraju, dla wycieczek objazdowych wpisujemy EU. 3. człon to pierwsze litery, pierwszych dwóch wyrazów nazwy. W przypadku podobnych produktów można dołożyć trzecią literę (np. 3 Stolice Południowe to 3S, 3 Stolice Bałtyckie to 3SB)"
				></i
				><small class="ms-2 text-danger">* wymagane</small>
			</h6>
		</div>
		<div class="col-1 px-2">
			<mat-form-field class="w-100">
				<input matInput type="text" class="text-center" maxlength="2" [(ngModel)]="service.mockData.code1" />
			</mat-form-field>
		</div>
		<div class="col-1 px-2">
			<mat-form-field class="w-100">
				<input
					matInput
					type="text"
					class="text-center"
					[(ngModel)]="service.mockData.code2"
					(ngModelChange)="service.mockData.code2 = $event.toUpperCase()"
					minlength="2"
					maxlength="2"
					required
				/>
			</mat-form-field>
		</div>

		<div class="col-1">
			<mat-form-field class="w-100">
				<input
					matInput
					type="text"
					class="text-center"
					[(ngModel)]="service.mockData.code3"
					(ngModelChange)="service.mockData.code3 = $event.toUpperCase()"
					minlength="2"
					maxlength="3"
					required
				/>
			</mat-form-field>
		</div>
	</div>
	<div class="mx-2">
		<div class="form-floating mb-3 px-2">
			<h6
				matTooltip="Informacje działu organizacji dotyczące wyjazdu czy obiektu (nie jest publikowana na stronie)"
			>
				Notatki organizacji
			</h6>
			<app-editor [(value)]="service.data.organizationNote" [disabled]="editable"></app-editor>
		</div>
	</div>

	<div class="mx-2">
		<div class="form-floating mb-3 px-2">
			<h6>Nocna impreza</h6>
			<mat-slide-toggle [(ngModel)]="service.data.isNightEvent"></mat-slide-toggle>
		</div>
	</div>
</fieldset>
